/* eslint-disable no-sequences */
import * as React from "react";
import env from '../../env';
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { userAction } from "../../actions/user.action";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import withStyles from "@material-ui/core/styles/withStyles";
import Collapse from "@material-ui/core/Collapse";
import Toolbar from "@material-ui/core/Toolbar";
import { API } from "../../utilities/api.config";
import PropTypes from "prop-types";
import MinimizeIcon from "@material-ui/icons/Minimize";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios/index";
import ChatFeed from "./components/ChatFeed";
import CustomBubble from "./components/ChatBubble";
import { QuestionTree } from "./components/QuestionTree";

const styles = (theme) => ({
  collapseEntered: {
    height: "600px !important",
    [theme.breakpoints.down("md")]: {
      height: "100% !important",
    },
  },
  collapse: {
    boxShadow: "0 0 10px rgb(0 0 0 / 60%)",
    borderRadius: 14,
    height: 600,
    maxHeight: 600,
    width: 420,
    maxWidth: 420,
    position: "fixed",
    left: 120,
    bottom: 120,
    [theme.breakpoints.down("md")]: {
      height: "100%",
      width: "100%",
      left: 0,
      bottom: 0,
      maxHeight: "100%",
      maxWidth: "100%",
    },
  },
  wrapper: {
    height: "inherit",
    maxHeight: "inherit",
  },
  wrapperInner: {
    height: "inherit",
    maxHeight: "inherit",
  },

  grow: {
    flexGrow: 1,
  },
  contentWrapper: {
    width: "100%",
    height: "inherit",
    maxHeight: "inherit",
    display: `flex`,
    flexDirection: "column",
  },
  chatHeader: {
    zIndex: 1101,
    position: "relative",
    padding: "0px 8px",
  },
  chatWrapper: {
    borderRadius: 14,
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  content: {
    margin: 20,
  }
});
class ChatWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      openHelpDialog: false,
      wasMinimized: false,
      creatingTicket: false,
      submissionError: false,
      createdTicket: null,
      tickets: [],
      treeStep: null,
      questionPath: "defaultOptions",
      messages: [
        ...QuestionTree["defaultOptions"].steps[0].questions,
        ...QuestionTree["defaultOptions"].steps[0].responses,
      ],
      prevMessages: [],
      curr_user: 0,
      closeChat: false,
    };
  }

  scrollToBottom = () => {
    setTimeout(
      () =>
        this.messagesEnd
          ? this.messagesEnd.scrollIntoView({ behavior: "smooth" })
          : null,
      1550
    );
  };
  updateMinimizeChat() {
    this.setState({ wasMinimized: true });
    this.props.handleMinimizeChat();
  }
  componentDidUpdate() {
    this.scrollToBottom();
  }

  getRequestsTypes = () => {
    axios
      .get(`${API.JIRA}/getRequestTypes`, {
        headers: { Authorization: localStorage.getItem("wbiAuthToken") },
      })
      .then((response) => this.setState({ requestTypes: response.data.values }))
      .catch((err) =>
        this.setState({
          errorMessage: err.response.data.error,
        })
      );
  };

  createCustomer = (body) => {
    axios
      .post(`${API.JIRA}/createCustomer`, body, {
        headers: { Authorization: localStorage.getItem("wbiAuthToken") },
      })
      .then(
        (response) => (
          this.setState({ jiraId: response.data.accountId }),
          this.props.dispatch(
            userAction.updateJiraUser(response.data.accountId)
          )
        )
      )
      .catch(
        (err) => (
          console.log(err.response.data.error),
          this.setState({
            createdTicket: true,
            creatingTicket: false,
            submissionError: true,
            errorMessage: err.response.data.error,
          })
        )
      );
  };
  componentDidMount() {
    this.scrollToBottom();
    // get requests from jira for dropdown
    this.getRequestsTypes();
    // get the user a jira id if they dont have one
    if (
      this.props.user.user.jiraId === null ||
      this.props.user.user.jiraId === undefined
    ) {
      this.createCustomer({
        firstName: this.props.user.user.firstName,
        lastName: this.props.user.user.lastName,
        email: this.props.user.user.email,
        userId: this.props.user.user.id,
      });
    } else {
      this.setState({
        jiraId: this.props.user.user.jiraId,
      });
    }
  }

  render() {
    const { classes, openChatFeed, handleCloseChat, theme } = this.props;
    const {
      messages,
      treeStep,
      creatingTicket,
      createdTicket,
      errorMessage,
      jiraId,
      requestTypes,
      prevMessages,
      submissionError,
    } = this.state;

    const createRequests = (body) => {
      axios
        .post(`${API.JIRA}/createRequest`, body, {
          headers: { Authorization: localStorage.getItem("wbiAuthToken") },
        })
        .then(() =>
          this.setState({
            creatingTicket: false,
            createdTicket: true,
            submissionError: false,
          })
        )
        .catch((err) =>
          this.setState({
            errorMessage: err.response.data.error,
            createdTicket: true,
            creatingTicket: false,
            submissionError: true,
          })
        );
    };

    const handleOptionClick = (e, message) => {
      const prevState = this.state;
      // this gets the request types from jira.
      // for now we only have one so i am hardcoding the value to the first item returned.
      const helpTypes = requestTypes
        ? requestTypes.map((request) => request.name)
        : ["General support"];
      // eventually you can take this from the message obj. will need to turn the dropdown back on in the submit component
      const topic = helpTypes[0];
      const description = message.description;

      const questionPath = message.questionPath;
      const newQuestionPath = QuestionTree[questionPath].steps[
        prevState.treeStep + 1
      ]
        ? questionPath
        : prevState.questionPath === "defaultOptions"
        ? questionPath
        : 0;
      const nextStep =
        prevState.questionPath === newQuestionPath ? prevState.treeStep + 1 : 0;

      const submitMessage = topic !== undefined && description !== undefined;
      const requestType = requestTypes
        ? requestTypes.find((request) => request.name === topic)
        : { id: 1, name: "General support" };
      const path = window.location.href;

      const userPath =
        prevState.prevMessages &&
        prevState.prevMessages.length > 1 &&
        prevState.prevMessages.reduce(
          (path, message) => (message.selected && path.push(message), path),
          []
        );
      let jiraPath = "";
      if (userPath !== undefined && userPath.length > 1) {
        jiraPath = userPath
          .map((message) => message.message)
          .filter((message) => message !== "No")
          .filter((message) => message !== "Submit a help request")
          .map((message, index) => `${index + 1}. ${message}`)
          .join("\n");
        // for jira use \n when multi line is enabled
      }

      if (submitMessage) {
        const summary = description.replace(/\n/g, " ");
        this.setState({ creatingTicket: true });
        createRequests({
          requestParticipants: [jiraId],
          serviceDeskId: env.REACT_APP_JIRA_SERVICE_DESK_ID,
          raiseOnBehalfOf: jiraId,
          requestTypeId: requestType.id,
          requestFieldValues: {
            summary: summary,
            description: description,
            customfield_10044: path,
            customfield_10046: jiraPath,
          },
        });
      }

      const restart =
        questionPath === 0 &&
        message.messageId === 0 &&
        (message.treeStep === 3 || message.treeStep === 1);
      if (restart) {
        return this.setState({
          treeStep: null,
          questionPath: "defaultOptions",
          messages: [
            ...QuestionTree["defaultOptions"].steps[0].questions,
            ...QuestionTree["defaultOptions"].steps[0].responses,
          ],
          prevMessages: [],
          creatingTicket: false,
          createdTicket: null,
          submissionError: false,
          errorMessage: "",
        });
      }

      // consider for non linear paths

      // there are two paths that end the widget.
      const isEnd =
        questionPath === 0 &&
        message.messageId === 1 &&
        (message.treeStep === 0 || message.treeStep === 3);

      const isBeginning = nextStep === 0;

      // go to the help section when the path has ended and it is not the default path
      const startHelpStep =
        QuestionTree[newQuestionPath].steps[nextStep + 1] === undefined &&
        newQuestionPath > 0;

      // move to the help path when there are no more steps in a path

      // get the messages to ammend, the question and the users answer
      let prevMessages = prevState.prevMessages;

      let prevStepQuestions =
        prevMessages.length === 0
          ? [...QuestionTree["defaultOptions"].steps[0].questions]
          : [
              ...QuestionTree[prevState.questionPath].steps[prevState.treeStep]
                .questions,
            ];
      // need to get the prev message to filter only related responses.
      let prevStepResponses =
        prevMessages.length === 0
          ? [...QuestionTree["defaultOptions"].steps[0].responses]
          : [
              ...QuestionTree[prevState.questionPath].steps[
                prevState.treeStep
              ].responses.filter(
                (response) => response.prevResponse === message.prevResponse
              ),
            ];
      let messageIndex = prevStepResponses.indexOf(message);

      // the submit cases only has 1 response
      // all other responses have many reponses.

      submitMessage
        ? (prevStepResponses[prevStepResponses.length - 1] = {
            ...message,
            selected: true,
            description,
            topic: requestType.name,
            options: helpTypes,
            message: "Your request has been submitted.",
          })
        : (prevStepResponses[messageIndex] = {
            ...message,
            selected: true,
          });

      // add prev question
      prevMessages = [
        ...prevMessages,
        ...prevStepQuestions,
        ...prevStepResponses,
      ];

      //add the user response, update selected to change bubble styles

      // the next array of messages starts with where the user left off
      let nextMessages;
      nextMessages = prevMessages;
      // determine which responses to get

      const nextResponses = isEnd
        ? [...QuestionTree[0].steps["end"].responses]
        : isBeginning
        ? [...QuestionTree[newQuestionPath].steps[nextStep].responses]
        : [
            ...QuestionTree[newQuestionPath].steps[nextStep].responses.filter(
              (response) => response.prevResponse === message.messageId
            ),
          ];

      let nextQuestions = isEnd
        ? [...QuestionTree[0].steps["end"].questions]
        : [...QuestionTree[newQuestionPath].steps[nextStep].questions];

      const selectIndex = nextResponses.findIndex(
        (question) => question.componentType === "select"
      );

      if (selectIndex > -1) {
        nextResponses[selectIndex].options = helpTypes;
      }

      const nextStepMessages = [...nextQuestions, ...nextResponses];

      nextMessages = [...nextMessages, ...nextStepMessages];

      // for help messages, need to append previous first then help messages to maintain correct order
      prevMessages = startHelpStep ? [...nextMessages] : [...prevMessages];

      nextMessages = startHelpStep
        ? [
            ...nextMessages,
            ...QuestionTree[0].steps[0].questions,
            ...QuestionTree[0].steps[0].responses,
          ]
        : [...nextMessages];

      // then add the next relevant responses
      // and reset the path or steps if health
      return this.setState({
        treeStep: startHelpStep ? 0 : nextStep,
        questionPath: startHelpStep ? 0 : newQuestionPath,
        messages: nextMessages,
        prevMessages: prevMessages,
      });
    };

    return (
      <Collapse
        in={!openChatFeed}
        collapsedHeight={64}
        style={{
          display: openChatFeed ? "none" : "block",
        }}
        classes={{
          container: classes.collapse,
          wrapper: classes.wrapper,
          wrapperInner: classes.wrapperInner,
          entered: classes.collapseEntered,
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "white",
            borderRadius: "14px",
            fontSize: "initial",
          }}
        >
          <div className={classes.contentWrapper}>
            {/* float the header above */}
            <Toolbar disableGutters className={classes.chatHeader}>
              <div style={{ display: "flex" }}>
                <Typography
                  variant="h6"
                  style={{ color: theme.palette.secondary.charcoal }}
                >
                  Cy Help
                </Typography>
              </div>
              <div className={classes.grow} />
              <div style={{ display: "flex" }}>
                <IconButton
                  aria-label="minimize-icon"
                  size="medium"
                  onClick={() => this.updateMinimizeChat()}
                >
                  <MinimizeIcon
                    style={{
                      color: theme.palette.primary.main,
                    }}
                  />
                </IconButton>
                <IconButton
                  aria-label="minimize-icon"
                  size="medium"
                  onClick={() =>
                    this.setState({
                      openHelpDialog: !this.state.openHelpDialog,
                    })
                  }
                >
                  <CloseIcon style={{ color: theme.palette.primary.main }} />
                </IconButton>
                <Dialog open={this.state.openHelpDialog}>
                  <DialogTitle id="alert-dialog-slide-title">
                    Confirm
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                      Are you sure you want to close Cy Help?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() =>
                        this.setState({
                          openHelpDialog: !this.state.openHelpDialog,
                        })
                      }
                      variant="contained"
                      size="small"
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button onClick={handleCloseChat} size="small">
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </Toolbar>

            <div className={classes.chatWrapper}>
              <ChatFeed
                submissionError={submissionError}
                creatingTicket={creatingTicket}
                createdTicket={createdTicket}
                errorMessage={errorMessage}
                prevMessages={prevMessages}
                treeStep={treeStep}
                messages={messages} // Array: list of message objects
                chatBubble={CustomBubble}
                onClick={(e, value) => handleOptionClick(e, value)}
              />
              <div
                style={{ float: "left", clear: "both" }}
                ref={(el) => {
                  this.messagesEnd = el;
                }}
              />
            </div>
          </div>
        </div>
      </Collapse>
    );
  }
}

ChatWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  handleMinimizeChat: PropTypes.func.isRequired,
  handleCloseChat: PropTypes.func.isRequired,
  openChatFeed: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
  };
};
export default withRouter(
  withStyles(styles, { withTheme: true })(connect(mapStateToProps)(ChatWidget))
);



// WEBPACK FOOTER //
// ./src/components/HelpWidget/index.jsx